export default {
  ERROR: 'Erro interno',
  PROBLEM: 'Não encontramos a página que você está tentando acessar.',
  BACK_HOME: 'Voltar para página inicial',
};
